import { IShowArchivedSetAction } from './types';
import { AT_SHOW_ARCHIVED_SET } from './constants';

export const myWorkShowArchivedSet = (
    showArchived: boolean
): IShowArchivedSetAction => ({
    type: AT_SHOW_ARCHIVED_SET,
    showArchived
});
